export default class CreateSimulationRequest {
    name: string;
}